import { queryOptionConfig } from '@/api/ics_advertiser/manage.type'
import { format } from 'date-fns'

export const queryConfig = {
  accountOwner: 'MAIN',
  accountType: -1,
  accountStatus: 'All',
  fuzzyField: '',
  page: 1,
  page_size: 15,
}

export const tableColumnConfig = [
  {
    label: '广告主ID',
    prop: 'ssUid',
    width: 120,
  },
  {
    label: '广告主名称',
    prop: 'ssUsername',
  },
  {
    label: '邮箱',
    prop: 'email',
  },
  {
    label: '是否主账号',
    prop: 'mainAccountFlag',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.mainAccountFlag ? '是' : '否'
      },
    },
  },
  {
    label: '账户类型',
    prop: 'accountType',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.accountType) {
          case 0:
            return '试用账号'
          case 1:
            return '正式账号'
          case 2:
            return '内部账号'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '状态',
    prop: 'accountStatus',
    params: {
      innerHTML(o: any): any | string {
        const { row } = o
        switch (row.accountStatus) {
          case 'REGULAR':
            return '使用中'
          case 'OVERDUE':
            return '已过期'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '到期时间',
    prop: 'expireIn',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return format(row.expireIn, 'YYYY-MM-DD HH:mm:ss')
      },
    },
  },
  {
    label: '视频已用数量',
    prop: 'videoConsumeSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.mainAccountFlag ? row.videoConsumeSum : '-'
      },
    },
  },
  {
    label: '视频总数',
    prop: 'videoSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        if (row.mainAccountFlag) {
          return row.videoSum === -1 ? '不限量' : row.videoSum
        }
        return '-'
      },
    },
  },
  {
    label: '图片已用数量',
    prop: 'imgConsumeSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.mainAccountFlag ? row.imgConsumeSum : '-'
      },
    },
  },
  {
    label: '图片总数',
    prop: 'imgSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        if (row.mainAccountFlag) {
          return row.imgSum === -1 ? '不限量' : row.imgSum
        }
        return '-'
      },
    },
  },
  {
    slot: 'is_account',
  },
  {
    slot: 'action-cell',
  },
]

const accountList = [
  {
    value: 'All',
    label: '全部',
  },
  {
    value: 'MAIN',
    label: '主账号',
  },
  {
    value: 'SUB',
    label: '子账号',
  },
]

export const typeList = [
  {
    value: 0,
    label: '试用账号',
  },
  {
    value: 1,
    label: '正式账号',
  },
  {
    value: 2,
    label: '内部账号',
  },
]

const stateList = [
  {
    value: 'All',
    label: '全部状态',
  },
  {
    value: 'REGULAR',
    label: '使用中',
  },
  {
    value: 'OVERDUE',
    label: '已过期',
  },
]

const getTypeOptions = () => {
  return [
    {
      value: -1,
      label: '全部类型',
    },
  ].concat(typeList)
}

export const formItemConfig = [
  {
    prop: 'accountOwner',
    type: 'select',
    params: {
      placeholder: '全部',
      clearable: false,
      options: accountList,
    },
  },
  {
    prop: 'accountType',
    type: 'select',
    params: {
      placeholder: '全部类型',
      clearable: false,
      options: getTypeOptions(),
    },
  },
  {
    prop: 'accountStatus',
    type: 'select',
    params: {
      placeholder: '全部状态',
      clearable: false,
      options: stateList,
    },
  },
  {
    type: 'input',
    prop: 'fuzzyField',
    params: {
      clearable: true,
      style: 'width: 230px;',
      placeholder: '请输入广告主ID/用户名称/邮箱',
    },
  },
]

export const historyColumn = [
  {
    label: '广告主ID',
    prop: 'ssUid',
    width: 120,
  },
  {
    label: '用户名称',
    prop: 'ssUsername',
  },
  {
    label: '邮箱',
    prop: 'email',
  },
  {
    label: '类型',
    prop: 'accountType',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.accountType) {
          case 0:
            return '试用账号'
          case 1:
            return '正式账号'
          case 2:
            return '内部账号'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '到期时间',
    prop: 'expireIn',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return format(row.expireIn, 'YYYY-MM-DD HH:mm:ss')
      },
    },
  },
  {
    label: '是否限量',
    prop: 'limitFlag',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.limitFlag ? '限量' : '不限量'
      },
    },
  },
  {
    label: '视频总量',
    prop: 'videoSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.limitFlag ? row.videoSum : '-'
      },
    },
  },
  {
    label: '图片总量',
    prop: 'imgSum',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.limitFlag ? row.imgSum : '-'
      },
    },
  },
  {
    label: '子账号数量',
    prop: 'subAccountNum',
  },
  {
    label: '更新时间',
    prop: 'updateTime',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return format(row.updateTime, 'YYYY-MM-DD HH:mm:ss')
      },
    },
  },
  {
    label: '操作者',
    prop: 'operator',
  },
]

export const accountColumn = [
  {
    label: '用户名',
    prop: 'username',
  },
]

export const CheckSearchQuery = (query?: queryOptionConfig) => {
  if (query) {
    return Object.assign(query, {
      accountType: query.accountType === -1 ? null : query.accountType,
      accountStatus: query.accountStatus === 'All' ? null : query.accountStatus,
    })
  }
}

export const refreshSearchQuery = (query?: queryOptionConfig) => {
  if (query) {
    return Object.assign(query, {
      accountType: Number(query.accountType),
    })
  }
}
